<template>
  <div>
    <div v-if="originObject">
      <div v-if="originObject.attachmentMobileMode == 0">
        <b-button
          :disabled="disabled"
          class="btn-photo-take"
          type="button"
          @click="openCamera()"
          size="sm"
        >
          <span class="icon" style="font-family: Helvetica, Arial, sans-serif">
            <i class="tim-icons icon-camera-18"> </i> Camera
          </span>
        </b-button>
        <input
          class="input-photo"
          ref="camera"
          type="file"
          capture
          accept="image/*;capture=camera"
          @change="captureImage($event)"
        />
      </div>
      <div v-if="originObject.attachmentMobileMode != 0">
        <b-button
          :disabled="disabled"
          class="btn-photo-take"
          type="button"
          @click="addFiles()"
          size="sm"
        >
          <span class="icon" style="font-family: Helvetica, Arial, sans-serif">
            <i class="tim-icons icon-attach-87"> </i> {{ getLabel }}
          </span>
        </b-button>
        <input
          class="input-photo"
          ref="files"
          type="file"
          :accept="acceptedFileTypes"
          @change="captureImage($event)"
        />
        <b-button
          :disabled="disabled"
          class="btn-photo-take"
          type="button"
          @click="openCamera()"
          size="sm"
        >
          <span class="icon" style="font-family: Helvetica, Arial, sans-serif">
            <i class="tim-icons icon-camera-18"> </i> Camera
          </span>
        </b-button>
        <input
          class="input-photo"
          ref="camera"
          type="file"
          capture
          accept="image/*;capture=camera"
          @change="captureImage($event)"
        />
      </div>
    </div>
    <div v-else>
      <b-button
        :disabled="disabled"
        class="btn-photo-take"
        type="button"
        @click="openCamera()"
        size="sm"
      >
        <span class="icon" style="font-family: Helvetica, Arial, sans-serif">
          <i class="tim-icons icon-attach-87"> </i> Anexo
        </span>
      </b-button>
      <input
        class="input-photo"
        ref="camera"
        type="file"
        :capture="allowDocuments ? null : true"
        :accept="acceptedFileTypes"
        @change="captureImage($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CameraButton",
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: Boolean,
    originObject: Object,
    allowDocuments: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      draftImageSrc: "",
    };
  },
  computed: {
    getLabel() {
      if (this.label) return this.label;
      return this.$t("geral.fileAdd");
    },
    acceptedFileTypes() {
      return this.allowDocuments
        ? "image/*,application/pdf"
        : "image/*;capture=camera";
    },
  },
  methods: {
    addFiles() {
      this.$refs.files.click();
    },
    openCamera() {
      this.$refs.camera.click();
    },
    captureImage(e) {
      let input = e.target;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        var reader = new FileReader();
        let _this = this;

        reader.onload = (e) => {
          if (!file.type.startsWith("image/")) {
            _this.draftImageSrc = e.target.result;
            _this.emitAttachment(_this.draftImageSrc);
            input.value = "";
            return;
          }

          var img = document.createElement("img");
          img.src = e.target.result;

          img.onload = () => {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 1920;
            var MAX_HEIGHT = 1920;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            _this.draftImageSrc = canvas.toDataURL("image/jpeg", 0.5);
            _this.emitAttachment(_this.draftImageSrc);
            input.value = "";
          }; // img.onload
        };
        reader.readAsDataURL(file);
      }
    },
    emitAttachment(attachment) {
      if (this.originObject) {
        this.$emit("update-image-src", this.originObject, attachment);
      } else {
        this.$emit("update-image-src", attachment);
      }
    },
  },
};
</script>

<style scoped>
.input-photo {
  display: none;
}
</style>
